import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ion-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_HeaderMessengerButton = _resolveComponent("HeaderMessengerButton")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border events-page-header" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": "/admin-promo-codes"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isNew ? 'Новый промокод' : 'Промокод'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_HeaderMessengerButton)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.code) = $event)),
                  label: "Код",
                  "label-placement": "stacked",
                  placeholder: "SUMMER25",
                  disabled: !_ctx.isNew && _ctx.saving
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.percentOff,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.percentOff) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  label: "Скидка %",
                  "label-placement": "stacked",
                  min: "1",
                  max: "100"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.validFromLocal,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.validFromLocal) = $event)),
                  type: "datetime-local",
                  label: "Действует с",
                  "label-placement": "stacked"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.validToLocal,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.validToLocal) = $event)),
                  type: "datetime-local",
                  label: "Действует до",
                  "label-placement": "stacked"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.maxRedemptions,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.maxRedemptions) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  label: "Лимит использований (пусто = без лимита)",
                  "label-placement": "stacked"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.maxPerUser,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.maxPerUser) = $event)),
                  modelModifiers: { number: true },
                  type: "number",
                  label: "Лимит на пользователя",
                  "label-placement": "stacked",
                  min: "1"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_select, {
                  modelValue: _ctx.form.targetType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.targetType) = $event)),
                  label: "Область",
                  "label-placement": "stacked",
                  interface: "action-sheet",
                  "cancel-text": "Отмена",
                  onIonChange: _ctx.onTargetTypeChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select_option, { value: "SUBSCRIPTION" }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode("Подписки", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select_option, { value: "EVENT" }, {
                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                        _createTextVNode("События", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_ion_select_option, { value: "ALL" }, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("Подписки и события", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onIonChange"])
              ]),
              _: 1
            }),
            (_ctx.form.targetType === 'SUBSCRIPTION')
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 0,
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      modelValue: _ctx.form.subscriptionId,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.subscriptionId) = $event)),
                      label: "Подписка",
                      "label-placement": "stacked",
                      interface: "action-sheet",
                      "cancel-text": "Отмена",
                      placeholder: "Все подписки"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: null }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("Все подписки", -1)
                          ]))]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions, (s) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: s.id,
                            value: s.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.subscriptionLabel(s)), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.form.targetType === 'EVENT')
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 1,
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_select, {
                      modelValue: _ctx.form.eventId,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.eventId) = $event)),
                      label: "Событие",
                      "label-placement": "stacked",
                      interface: "action-sheet",
                      "cancel-text": "Отмена",
                      placeholder: "Все события"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select_option, { value: null }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode("Все события", -1)
                          ]))]),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (e) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: e.id,
                            value: e.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(e.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.form.active,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.active) = $event))
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Активен", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              expand: "block",
              class: "event-register-btn",
              disabled: _ctx.saving,
              onClick: _ctx.save
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.saving ? 'Сохранение…' : 'Сохранить'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            (!_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 2,
                  expand: "block",
                  fill: "outline",
                  color: "danger",
                  disabled: _ctx.saving,
                  onClick: _ctx.remove
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" Удалить ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}